import { render, staticRenderFns } from "./DownloadDlg.vue?vue&type=template&id=0b7ac6be&scoped=true"
import script from "./DownloadDlg.ts?vue&type=script&lang=ts&external"
export * from "./DownloadDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./DownloadDlg.scss?vue&type=style&index=0&id=0b7ac6be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ac6be",
  null
  
)

export default component.exports